import React, { useEffect } from 'react';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

import { setLocale } from '../../actions/intl';
import { closeHeaderModal } from '../../actions/modalActions';

import { formatLocale, isRTL } from '../../helpers/formatLocale';


import s from './LanguageModal.css';

function LanguageModal(props) {
  const dispatch = useDispatch();

  const availableLocales = useSelector(state => state.runtime.availableLocales);
  const currentLocale = useSelector(state => state.intl.locale);
  const isActiveLanguages = useSelector(state => state?.runtime?.isActiveLanguages);

  const handleChange = async (value) => {
    const isRtlLocale = value && isRTL(value);

    await dispatch(closeHeaderModal('languageModal'));

    if (isRtlLocale) {
      document.body.classList.add('rtl');
    } else if (isRTL(currentLocale) && !isRtlLocale) {
      const rtlStyleElement = document.getElementById('rtl-style');
      if (rtlStyleElement) {
        rtlStyleElement.parentNode.removeChild(rtlStyleElement);
      }
      document.body.className = document.body.className.replace(/\brtl\b/g, '');
    }

    dispatch(setLocale({ locale: value }));

    moment.defineLocale(value + '-dup', {
      parentLocale: isRTL(value) ? value : 'en',
      preparse: string => string,
      postformat: string => string
    });
  };


  let localeList = isActiveLanguages && isActiveLanguages.filter(o => o !== currentLocale);

  useEffect(() => {
    const headID = document.getElementsByTagName('head')[0];
    const link = document.createElement('link');
    link.type = 'text/css';
    link.rel = 'stylesheet';
    link.id = 'rtl-style';
    link.href = '/css/app-rtl.min.css';
    headID.appendChild(link);
  }, []);

  return (
    <div className={s.currencyAndLangGrid}>
      <div className={cx(s.activeItem, s.activeSection)} onClick={() => dispatch(closeHeaderModal('languageModal'))}>
        {formatLocale(currentLocale)}
      </div>

      {localeList?.map((item, key) => (
        <div key={key} onClick={() => handleChange(item)} className={cx(s.activeItem)}>
          {formatLocale(item)}
        </div>
      ))}
    </div>
  );
}

export default withStyles(s)(LanguageModal);
